import React, { Component } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Select from "react-select";
import RemotingService from "../../../../../services/remoting-service/RemotingService";
import DirectBillingReferralTypeEnum from "../../../enums/DirectBillingReferralTypeEnum";
import ExternalClinicianSelect from "../../component/ExternalClinicianSelect";

export default class ReferralCliniciansTab extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allStaff: [],
            specialityStaff: [],
        };
    }

    componentDidMount() {
        this.fetchAllStaff();
        this.fetchSpecialityStaff();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.referral?.speciality !== this.props.referral?.speciality) {
            this.fetchSpecialityStaff();
        }
    }

    fetchAllStaff() {
        RemotingService.getRemoteCall('api/staff/list-base', null, (result) => {
            const allStaff = (result.items || []).map(s => ({ value: s.id, label: s.name }));
            this.setState({ allStaff });
        });
    }

    fetchSpecialityStaff() {
        const speciality = this.props.referral?.speciality;
        const params = speciality ? { speciality } : null;
        RemotingService.getRemoteCall('api/staff/list-base', params, (result) => {
            const specialityStaff = (result.items || []).map(s => ({ value: s.id, label: s.name }));
            this.setState({ specialityStaff });
        });
    }

    render() {
        const { referral, onReferralChange, readOnly } = this.props;
        const { allStaff, specialityStaff } = this.state;
        const isExternal = DirectBillingReferralTypeEnum[referral.type] === DirectBillingReferralTypeEnum.EXTERNAL;

        const selectStyles = {
            control: (base) => ({ ...base, minHeight: '26px', height: '26px', fontSize: '14px', padding: '0px' }),
            valueContainer: (base) => ({ ...base, height: '26px', padding: '0 8px' }),
            input: (base) => ({ ...base, margin: '0px', padding: '0px' }),
            indicatorsContainer: (base) => ({ ...base, height: '26px' }),
            option: (base) => ({ ...base, fontSize: '13px', padding: '6px 8px' }),
        };

        const referringStaffValue = referral.referringClinician
            ? { value: referral.referringClinician.id, label: referral.referringClinician.name }
            : null;
        const performingValue = specialityStaff.find(o => o.value === referral.performingClinician?.id) || null;

        const performingSelect = (
            <Select
                options={specialityStaff}
                styles={selectStyles}
                value={performingValue}
                isDisabled={readOnly}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(opt) => onReferralChange && onReferralChange(referral.id, 'performingClinician', opt ? { id: opt.value, name: opt.label } : null)}
            />
        );

        if (isExternal) {
            return (
                <Container>
                    <Row>
                        <Col xs={10}>
                            <Field label="Referring Clinician Name" body={
                                <ExternalClinicianSelect
                                    field="name"
                                    value={referral.referringClinicianName}
                                    disabled={readOnly}
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    onTextChange={(text) => onReferralChange && onReferralChange(referral.id, 'referringClinicianName', text)}
                                    onClinicianSelect={(clinician) => {
                                        if (!onReferralChange) return;
                                        onReferralChange(referral.id, 'referringClinicianName', clinician.name);
                                        onReferralChange(referral.id, 'referringClinicianLicenseNo', clinician.licenseNo);
                                    }}
                                />
                            }/>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={10}>
                            <Field label="Referring Clinician Licence" body={
                                <ExternalClinicianSelect
                                    field="licenseNo"
                                    value={referral.referringClinicianLicenseNo}
                                    disabled={readOnly}
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    onTextChange={(text) => onReferralChange && onReferralChange(referral.id, 'referringClinicianLicenseNo', text)}
                                    onClinicianSelect={(clinician) => {
                                        if (!onReferralChange) return;
                                        onReferralChange(referral.id, 'referringClinicianName', clinician.name);
                                        onReferralChange(referral.id, 'referringClinicianLicenseNo', clinician.licenseNo);
                                    }}
                                />
                            }/>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={10}>
                            <Field label="Performing Clinician" body={performingSelect}/>
                        </Col>
                    </Row>
                </Container>
            );
        }

        return (
            <Container>
                <Row>
                    <Col xs={10}>
                        <Field label="Referring Clinician" body={
                            <Select
                                options={allStaff}
                                styles={selectStyles}
                                value={referringStaffValue}
                                isDisabled={readOnly}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                onChange={(opt) => onReferralChange && onReferralChange(referral.id, 'referringClinician', opt ? { id: opt.value, name: opt.label } : null)}
                            />
                        }/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={10}>
                        <Field label="Performing Clinician" body={performingSelect}/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

class Field extends Component {
    render() {
        const { label, body } = this.props;
        return (
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4, gap: '10px' }}>
                <div style={{ minWidth: '160px', fontWeight: 'bold' }}>{label}:</div>
                <div style={{ flex: 1 }}>{body}</div>
            </div>
        );
    }
}
